import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import AdminDrawer from "../../components/AdminDrawer";
import {
  Grid,
  Typography,
  Stack,
  Modal,
  Box,
  TextField,
  Button,
} from "@mui/material";
import GeneralSkeletons from "../../components/GeneralSkeletons";
import PersonalInfoCard from "./components/PersonalInfoCard";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { getAllUsers, updateUserInfo, getUserStats } from "../../apis";

const style = {
  position: "absolute",
  top: "25%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "white",
  p: 4,
};

const UserStats = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState(null);
  const [open, setOpen] = useState(false);
  const [modalError, setModalError] = useState(false);
  const [email, setEmail] = useState("");
  const [fullName, setFullName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [statsData, setStatsData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getAllUsers();
      setUsers(response.data.users);
      setLoading(false);
    };
    fetchData();
  }, []);

  const HandleOnClick = (id) => {
    const filteredResult = users.filter((item) => item._id == id);
    setSelectedUser(filteredResult[0]);
    setFullName(filteredResult[0].fullName);
    setEmail(filteredResult[0].email);
    setOpen(true);
    setModalError(false);
  };

  const handleClose = () => setOpen(false);

  const updateUserInfoHandler = async () => {
    if (email == "" || fullName == "") {
      setErrorMessage("Please fill all of the required fields.");
      setModalError(true);
    } else {
      const userInfoResponse = await updateUserInfo({
        id: selectedUser._id,
        email: email,
        fullName: fullName,
      });
      if (userInfoResponse.data.message == "User email already exist!") {
        setErrorMessage(userInfoResponse.data.message);
        setModalError(true);
      } else {
        const response = await getAllUsers();
        setUsers(response.data.users);
        setLoading(false);
        setOpen(false);
        setModalError(false);
      }
    }
  };

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  const applyButtonHandler = async () => {
    const convertedfrom = convert(fromDate);
    const convertedto = convert(toDate);
    const response = await getUserStats(convertedfrom, convertedto);
    setStatsData(response.data);
  };

  return (
    <>
      <Navbar />

      {/* <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Stack spacing={2}>
            {modalError ? (
              <Stack>
                <Typography style={{ color: "red" }}>{errorMessage}</Typography>
              </Stack>
            ) : (
              <></>
            )}
            <Stack>
              <Typography>Full Name</Typography>
              <TextField
                size="small"
                id="outlined-basic"
                placeholder="Enter Title"
                variant="outlined"
                className="w-100 mt-5"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
              />
            </Stack>
            <Stack>
              <Typography>Email</Typography>
              <TextField
                size="small"
                id="outlined-basic"
                placeholder="Enter your email address"
                variant="outlined"
                className="w-100 mt-5"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Stack>

            <Stack direction="row" justifyContent="flex-end" spacing={2}>
              <Button
                variant="outlined"
                className="default-color default-border"
                style={{ textTransform: "capitalize" }}
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                className="primary-button"
                style={{ textTransform: "capitalize" }}
                onClick={updateUserInfoHandler}
              >
                Submit
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal> */}

      <div className="ml-16">
        <Grid container rowSpacing={2} columnSpacing={4} className="mt-10">
          <Grid item xs={2}>
            <AdminDrawer page="User Stats" />
          </Grid>
          <Grid item xs={10}>
            <Grid container>
              <Grid item sm={9}>
                <Typography className="mb-16" variant="h6">
                  User Stats
                </Typography>

                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <Stack direction="row" spacing={6}>
                    <Stack spacing={1} className="w-100">
                      <Typography className="field-label">From</Typography>
                      <DesktopDatePicker
                        value={fromDate}
                        minDate={new Date("2017-01-01")}
                        onChange={(newValue) => {
                          setFromDate(newValue);
                        }}
                        renderInput={(params) => (
                          <TextField {...params} size="small" />
                        )}
                        disableFuture
                      />
                    </Stack>

                    <Stack spacing={1} className="w-100">
                      <Typography className="field-label">To</Typography>
                      <DesktopDatePicker
                        value={toDate}
                        minDate={
                          fromDate == null ? new Date("2017-01-01") : fromDate
                        }
                        onChange={(newValue) => {
                          setToDate(newValue);
                        }}
                        renderInput={(params) => (
                          <TextField {...params} size="small" />
                        )}
                        disabled={fromDate == null ? true : false}
                        disableFuture
                      />
                    </Stack>
                    <Stack spacing={1} alignSelf="flex-end">
                      <Button
                        variant="contained"
                        className="primary-button"
                        style={{ textTransform: "capitalize" }}
                        onClick={applyButtonHandler}
                      >
                        Apply
                      </Button>
                    </Stack>
                  </Stack>
                </LocalizationProvider>

                <Stack direction="row" spacing={4}>
                  <Stack className="w-100">
                    <Typography className="mt-16" variant="h6">
                      User Signed Up
                    </Typography>
                    <Typography className="ammanat-darker-gray">
                      {statsData == null ? 0 : statsData.users}
                    </Typography>
                  </Stack>

                  <Stack className="w-100">
                    <Typography className="mt-16" variant="h6">
                      Service Providers Signed Up
                    </Typography>
                    <Typography className="ammanat-darker-gray">
                      {statsData == null ? 0 : statsData.serviceProviders}
                    </Typography>
                  </Stack>
                </Stack>

                {/* <div
                  style={{ border: "1px solid #EEEBEF", borderRadius: "6px" }}
                  className="mb-16"
                >
                  <Stack spacing={2}>
                    {users.length && loading == false ? (
                      users.map((item) => (
                        <>
                          <PersonalInfoCard
                            title={item.fullName}
                            email={item.email}
                            id={item._id}
                            clickHandler={HandleOnClick}
                          />
                        </>
                      ))
                    ) : users.length == 0 && loading == false ? (
                      <>
                        <Typography>No Users Found</Typography>
                      </>
                    ) : (
                      <>
                        <GeneralSkeletons />
                        <GeneralSkeletons />
                        <GeneralSkeletons />
                        <GeneralSkeletons />
                        <GeneralSkeletons />
                      </>
                    )}
                  </Stack>
                </div> */}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default UserStats;
